import { z } from 'zod';

import { MAX_BID_VALUE } from './ProxyBidActions.const';

export const BidInputSchema = z
	.string()
	.transform((val) => val.replaceAll(',', ''))
	.pipe(z.coerce.number().multipleOf(1).min(1).max(MAX_BID_VALUE));
